import { useUserContext } from '@/components/user-context/user-context-provider';

import { LoggedInJpd } from './logged-in/logged-in-jpd';
import { LoggedOutJpd } from './logged-out/logged-out-jpd';

export const JpdSignup = () => {
	const {
		user: { isUserLoggedIn },
	} = useUserContext();

	if (isUserLoggedIn) {
		return <LoggedInJpd />;
	}

	return <LoggedOutJpd />;
};
